module.exports = __webpack_public_path__ + "static/engie-digital-logo-33c90de1dc2221801ede1edf6e258fa1.jpg";